import React, { Fragment } from "react";
import "./about.css";
import Breadcrumb from "../../commons/breadcrumb/breadcrumb";
import UserTeam from "../../commons/user-team/user-team";
const About = () => {
  return (
    <Fragment>
      <div className="container-fluid about_page_body">
        <div className="container page_body">
          <Breadcrumb bread2="درباره ما" />
          <div className="about_body">
            <div className="about_page_title">
              <h3>درباره ما</h3>
            </div>
            <div className="about_page_text">
              <p>
                تیم عروسکی از مرداد ماه 1389 در تهران بصورت حرفه ای شروع به کار
                کرد . ما مفتخر به ارائه خدمات به بیش از 1200 کاربر از تمامی سنین
                هستیم .
              </p>
              <p>سرمایه ما اعتماد شماست .</p>
            </div>
            <div className="row user_team_sec">
              <div className="col-xs-12 col-sm-12 col-md-4 col-lg col-xl-4">
                {" "}
                <UserTeam
                  desc1="توضیحات رضا"
                  desc2=""
                  image="https://s18.picofile.com/file/8440300042/2.png"
                  job="مسئول تیم امنیت"
                  name="رضا"
                />
              </div>
              <div className="col-xs-12 col-sm-12 col-md-4 col-lg col-xl-4">
                {" "}
                <UserTeam
                  desc1="توضیحات اسماعیل"
                  desc2="توضیحات اسماعیل 2
                  "
                  image="https://s19.picofile.com/file/8440297568/75561736.jpg"
                  job="برنامه نویس ، طراح سایت و سئو کار"
                  name="محسن نبوی"
                />
              </div>
              <div className="col-xs-12 col-sm-12 col-md-4 col-lg col-xl-4">
                {" "}
                <UserTeam
                  desc1="توضیحات محسن کریمی "
                  image="https://s19.picofile.com/file/8440301026/e3.jpg"
                  job="برنامه نویس ، طراح سایت و بازاریاب"
                  name="محسن کریمی"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default About;
